import React from 'react';
import { CheckIcon, AwardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function DeliverablesSection() {
  const deliverables = ['Tu Business Manager creado y configurado.', 'Conexión básica con tu página de Facebook/Instagram.', 'Al menos una campaña real lanzada (o lista para lanzar).', 'Claridad sobre qué objetivo usar según lo que quieres lograr.', 'Textos de anuncio y creativos sencillos creados por ti (con ayuda de IA).', 'Entendimiento básico de las métricas para no ir completamente a ciegas.', 'La confianza de decir: "Sé cómo crear y lanzar campañas simples en Meta Ads desde cero."'];
  return <section className="w-full bg-gradient-to-b from-gray-900 to-gray-800 text-white py-16 md:py-24" data-id="element-195">
      <div className="max-w-4xl mx-auto px-6" data-id="element-196">
        <div className="text-center mb-12" data-id="element-197">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0866FF] rounded-full mb-6" data-id="element-198">
            <AwardIcon className="w-8 h-8 text-white" data-id="element-199" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-200">
            Qué te llevas al terminar el curso
          </h2>
        </div>

        <div className="bg-white/10 backdrop-blur rounded-2xl p-8 md:p-10 mb-8" data-id="element-201">
          <p className="text-xl mb-6" data-id="element-202">
            Al terminar META ADS DESDE CERO tendrás:
          </p>
          <ul className="space-y-4" data-id="element-203">
            {deliverables.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-204">
                <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center mt-0.5" data-id="element-205">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-206" />
                </div>
                <span className="text-lg text-gray-200" data-id="element-207">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-blue-600 rounded-2xl p-8 text-center mb-10" data-id="element-208">
          <p className="text-xl" data-id="element-209">
            Y, además, una <strong data-id="element-210">base sólida</strong> para que si después
            quieres algo más avanzado (acompañamiento 1:1, escalado,
            contingencia…), ya no seas principiante perdido, sino alguien que
            entiende los fundamentos.
          </p>
        </div>

        <div className="text-center" data-id="element-211">
          <p className="text-xl text-gray-300 mb-8" data-id="element-212">
            ¿Listo para dejar de tenerle miedo a Meta Ads y aprender a crear tus
            primeras campañas desde cero?
          </p>
          <CTAButton size="large" scrollTo="pricing" data-id="element-213">
            Quiero unirme a la próxima edición →
          </CTAButton>
          <p className="text-sm text-gray-400 mt-4" data-id="element-214">
            Plazas limitadas para mantener las clases manejables. Si ves este
            botón activo, aún quedan lugares.
          </p>
        </div>
      </div>
    </section>;
}